import React from "react";
import { useNavigate } from "react-router-dom";
import "../assets/styles/registersuccess.css";

function RegisterSuccess() {

  const navigate = useNavigate();

  return (
    <div className="success-container">

      <div className="success-card">

        <h2>✅ Register Successfully!</h2>

        <p>
          Thank you for registering <b>SHUTTLE CRAFT BADMINTON ACADEMY</b>
        </p>

        <br/>

        <button 
          className="back-btn"
          onClick={() => navigate("/")}
        >
          Go Back
        </button>

      </div>

    </div>
  );
}
export default RegisterSuccess;